export default "__VITE_ASSET__71dc6bdf__"